"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryService = void 0;
var history_1 = require("../models/history");
var types_1 = require("../models/ticket/types");
var api_1 = require("./api");
var GAME_PATH = 'game/api';
var LOYALTY_PATH = '/loyalty/api';
var LEGACY_PATH = '/legacy/api/history';
var LOYALTY_PATH_V2 = 'loyalty/api/v2';
var EINSTANT_PATH = 'einstant/api/v1/bet';
var HistoryService = /** @class */ (function () {
    function HistoryService() {
    }
    HistoryService.getUserTicketEntriesHistory = function (size, page, sort, dateStart, dateEnd) {
        if (dateStart === void 0) { dateStart = ''; }
        if (dateEnd === void 0) { dateEnd = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var requestParams, url, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestParams = { size: size };
                        if (page) {
                            requestParams = __assign(__assign({}, requestParams), { page: page });
                        }
                        if (sort) {
                            requestParams = __assign(__assign({}, requestParams), { sort: sort });
                        }
                        else {
                            requestParams = __assign(__assign({}, requestParams), { sort: 'enteredTime,desc' });
                        }
                        if (!!dateStart && !!dateEnd) {
                            requestParams = __assign(__assign({}, requestParams), { 'enteredTime.greaterOrEqualThan': dateStart, 'enteredTime.lessOrEqualThan': dateEnd });
                        }
                        url = GAME_PATH + "/ticket-entries/history";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: url,
                                query: requestParams
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, {
                                data: history_1.TicketEntryHistory.JsonToTickets(response.content),
                                page: {
                                    last: response.last,
                                    first: response.first,
                                    totalElements: response.totalElements,
                                    totalPages: response.totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_1 = _a.sent();
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.getUserActivitiesHistory = function (pageNumber, pageSize) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: LOYALTY_PATH + "/user/user-activity/history",
                                query: {
                                    pageSize: pageSize,
                                    pageNumber: pageNumber
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.activityResponse(pageSize, response)];
                    case 2:
                        e_1 = _a.sent();
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.filterUserActivitiesHistory = function (dateStart, dateEnd, paging) {
        if (paging === void 0) { paging = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var query, pageSize, response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = __assign({ dateStart: dateStart,
                            dateEnd: dateEnd }, paging);
                        pageSize = paging && paging.pageSize ? paging.pageSize : 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: LOYALTY_PATH + "/user/user-activity/history/filter",
                                query: query
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, this.activityResponse(pageSize, response)];
                    case 3:
                        e_2 = _a.sent();
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.activityResponse = function (pageSize, response) {
        if (response) {
            var data = history_1.HistoryActivity.JsonToActivities(response);
            return {
                content: data,
                lastPage: data.length === 0 || data.length < pageSize
            };
        }
        return {
            historyActivities: undefined,
            lastPage: undefined
        };
    };
    HistoryService.getUserRewardsHistoryV2 = function (size, page, dateStart, dateEnd) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: LOYALTY_PATH_V2 + "/rewards/history",
                                query: {
                                    pageSize: size,
                                    pageNumber: page + 1,
                                    dateStart: dateStart,
                                    dateEnd: dateEnd
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        if (response && response.redemptions) {
                            data = history_1.HistoryReward.JsonToRewards(response.redemptions);
                            return [2 /*return*/, {
                                    historyRewards: data,
                                    rewardsLastPage: data.length < size || response.paging.total <= size
                                }];
                        }
                        return [2 /*return*/, {
                                historyRewards: undefined,
                                rewardsLastPage: undefined
                            }];
                    case 2:
                        e_3 = _a.sent();
                        throw e_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.getUserRewardsHistory = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: LOYALTY_PATH + "/user/rewards/history"
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, history_1.HistoryReward.JsonToRewards(response)];
                    case 2:
                        e_4 = _a.sent();
                        throw e_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.fetchDrawsByIds = function (ticket) {
        return __awaiter(this, void 0, void 0, function () {
            var ids, requestParams, response_1, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        ids = [];
                        if (ticket && ticket.prizes && ticket.prizes.length) {
                            ids = ticket.prizes.filter(function (t) { return t.prizeType === types_1.PrizeType.ENTRY; }).map(function (p) { return p.externalId; });
                        }
                        if (!(ids.length > 0)) return [3 /*break*/, 2];
                        requestParams = ids.join(',');
                        return [4 /*yield*/, api_1.API.get({
                                url: GAME_PATH + "/draws-by-ids?ids=" + requestParams
                            })];
                    case 1:
                        response_1 = _a.sent();
                        if (response_1) {
                            ticket.prizes.forEach(function (prize) {
                                var drawData = response_1.find(function (draw) { return draw.id === Number(prize.externalId); });
                                prize.drawName = drawData ? drawData.name : null;
                            });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, ticket];
                    case 3:
                        e_5 = _a.sent();
                        throw e_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.getPendingPointsForTicketEntries = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, response, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        requestUrl = GAME_PATH + "/ticket-entries/points/pending/total";
                        return [4 /*yield*/, api_1.API.get({
                                url: requestUrl
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        e_6 = _a.sent();
                        throw e_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.getUserDrawsHistory = function (size, page) {
        return __awaiter(this, void 0, void 0, function () {
            var requestParams, url, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestParams = "";
                        if (page) {
                            requestParams = "page=" + page + "&" + requestParams;
                        }
                        if (size) {
                            requestParams = "size=" + size + "&" + requestParams;
                        }
                        url = GAME_PATH + "/draws/history?" + requestParams;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: url,
                                query: requestParams
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, {
                                data: history_1.HistoryDraw.JsonToDraws(response.content),
                                page: {
                                    last: response.last,
                                    first: response.first,
                                    totalElements: response.totalElements,
                                    totalPages: response.totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_2 = _a.sent();
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.getSecondChanceTicketHistory = function (drawId) {
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, response, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        requestUrl = GAME_PATH + "/draws/history/" + drawId + " ";
                        return [4 /*yield*/, api_1.API.get({
                                url: requestUrl
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        e_7 = _a.sent();
                        throw e_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.getUserPastActivityHistory = function (size, page) {
        return __awaiter(this, void 0, void 0, function () {
            var requestParams, url, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestParams = "";
                        if (page) {
                            requestParams = "page=" + page + "&" + requestParams;
                        }
                        if (size) {
                            requestParams = "size=" + size + "&" + requestParams;
                        }
                        url = LEGACY_PATH + "/activities?" + requestParams;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: url,
                                query: requestParams
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, {
                                data: response.content,
                                page: {
                                    last: response.last,
                                    first: response.first,
                                    totalElements: response.totalElements,
                                    totalPages: response.totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_3 = _a.sent();
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.getUserPastTicketsHistory = function (size, page) {
        return __awaiter(this, void 0, void 0, function () {
            var requestParams, url, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestParams = "";
                        if (page) {
                            requestParams = "page=" + page + "&" + requestParams;
                        }
                        if (size) {
                            requestParams = "size=" + size + "&" + requestParams;
                        }
                        url = LEGACY_PATH + "/tickets?" + requestParams;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: url,
                                query: requestParams
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, {
                                data: response.content,
                                page: {
                                    last: response.last,
                                    first: response.first,
                                    totalElements: response.totalElements,
                                    totalPages: response.totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_4 = _a.sent();
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.getEinstantBetHistoryGrouped = function (page, size) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: EINSTANT_PATH + "/transaction/consolidated",
                                query: {
                                    size: size,
                                    page: page
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        if (response) {
                            return [2 /*return*/, {
                                    data: history_1.HistoryEInstantGrouped.JsonToEInstantsGrouped(response.content),
                                    page: {
                                        last: response.last,
                                        first: response.first,
                                        totalElements: response.totalElements,
                                        totalPages: response.totalPages,
                                        number: response.number
                                    }
                                }];
                        }
                        return [2 /*return*/, {
                                data: undefined,
                                page: undefined
                            }];
                    case 2:
                        e_8 = _a.sent();
                        throw e_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HistoryService.getEinstantBetHistoryDetails = function (gameId, page, size) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: EINSTANT_PATH + "/transaction/game/" + gameId,
                                query: {
                                    size: size,
                                    page: page
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        if (response) {
                            return [2 /*return*/, {
                                    data: history_1.HistoryEInstant.JsonToEInstants(response.content),
                                    page: {
                                        last: response.last,
                                        first: response.first,
                                        totalElements: response.totalElements,
                                        totalPages: response.totalPages,
                                        number: response.number
                                    }
                                }];
                        }
                        return [2 /*return*/, {
                                historyEInstants: undefined,
                                activitiesLastPage: undefined
                            }];
                    case 2:
                        e_9 = _a.sent();
                        throw e_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return HistoryService;
}());
exports.HistoryService = HistoryService;
//# sourceMappingURL=history-service.js.map